import responseService from "../../services/responseService";

const state = {
  responses: [],
  commentType: null,
  coordinatesWithType: [],
  coordinates: [],
  stakeholderResponses: [],
  stakeholderResponseFilterOptions: [],
  filteredStakeholderResponses: []
};

const getters = {
  responses: state => {
    return state.responses;
  },
  coordinates: state => {
    return state.coordinates;
  },
  stakeholderResponses: state => {
    return state.stakeholderResponses;
  }
};

const actions = {
  getResponses({ commit }) {
    responseService.fetchResponses().then(response => {
      commit("SET_RESPONSES", response.data);
    });
  },
  addResponse({ commit }, response) {
    responseService.postResponses(response).then(() => {
      commit("ADD_RESPONSE", response);
    });
  },
  setResponseCoordinates({ commit }, coordinates) {
    commit("SET_RESPONSE_COORDINATES", coordinates);
  },
  addStakeholderResponses({ commit }, data) {
    responseService.getStakeholderResponses(data).then(response => {
      commit("ADD_STAKEHOLDER_RESPONSES", response.data);
    });
  },
  setCommentType({ commit }, commentType) {
    commit("SET_COMMENT_TYPE", commentType);
  },
  setResponseCoordinatesWithType({ commit }, coordinates) {
    commit("SET_RESPONSE_COORDINATES_WITH_TYPE", coordinates);
  },
};

const mutations = {
  SET_RESPONSES(state, response) {
    state.responses = response;
  },
  ADD_RESPONSE(state, response) {
    state.responses.push(response);
  },
  SET_RESPONSE_COORDINATES(state, coordinates) {
    state.coordinates = coordinates;
  },
  ADD_STAKEHOLDER_RESPONSES(state, response) {
    state.stakeholderResponses = response;
  },
  SET_COMMENT_TYPE(state, commentType) {
    state.commentType = commentType;
  },
  SET_RESPONSE_COORDINATES_WITH_TYPE(state, coordinatesWithType) {
    state.coordinatesWithType = coordinatesWithType;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
